import _ from "lodash";
import { makeCancellableAPIRequest } from "restAPI";
import {
  AnyaCancelDto,
  AnyaConversationRequestDto,
  AnyaEventDto,
  AnyaFeedbackDto,
  AnyaRequestDto,
  AnyaResponseDto,
  AnyaRetryDto,
} from "types/anya";
import { BaseResponse } from "types/api/aiRiskMgmt";

export function getAnyaAssistant(data: AnyaRequestDto) {
  return makeCancellableAPIRequest<BaseResponse<AnyaResponseDto>>(
    "POST",
    "/api/ai/assistant",
    {
      data,
    },
  );
}

export function storeFeedback(
  conversationId: string,
  queryParams: AnyaFeedbackDto,
) {
  const queryParamsString = new URLSearchParams(_.omitBy(queryParams, _.isNil));
  return makeCancellableAPIRequest<AnyaFeedbackDto>(
    "PUT",
    `/api/ai/assistant/conversations/${conversationId}/feedback?${queryParamsString}`,
  );
}

export function getAnyaConversations(params?: {
  excludeFindingRemediations?: boolean;
  widgetId?: string;
}) {
  return makeCancellableAPIRequest(
    "GET",
    "/api/ai/assistant/conversations/list",
    {
      params,
    },
  );
}

export function getAnyaConversationMessages(
  params: AnyaConversationRequestDto,
) {
  return makeCancellableAPIRequest(
    "GET",
    `/api/ai/assistant/conversations/${params.conversationId}`,
    {
      params,
    },
  );
}

export function deleteAnyaConversationMessages(conversationId: string) {
  return makeCancellableAPIRequest(
    "DELETE",
    `/api/ai/assistant/conversations/${conversationId}`,
  );
}

export function sendConfirmation(data: AnyaEventDto) {
  return makeCancellableAPIRequest("POST", "/api/ai/assistant/event", {
    data: {
      event: data.event,
      requestId: data.requestId,
      conversationId: data.conversationId,
    },
  });
}

export function retryRequest(data: AnyaRetryDto) {
  return makeCancellableAPIRequest<AnyaRetryDto>(
    "POST",
    "/api/ai/assistant/retry",
    {
      data,
    },
  );
}

export function cancelRequest(data: AnyaCancelDto) {
  return makeCancellableAPIRequest<AnyaCancelDto>(
    "PUT",
    "/api/ai/assistant/cancel",
    {
      data,
    },
  );
}

export function getAnyaMessage(params: {
  conversationId: string;
  messageId: string;
}) {
  return makeCancellableAPIRequest<BaseResponse<any>>(
    "GET",
    `/api/ai/assistant/message/${params.conversationId}/${params.messageId}`,
  );
}

export function storeWidgetData(params: {
  conversationId: string;
  messageId: string;
  widgetId: string;
  apiKey: string;
  data: unknown;
}) {
  return makeCancellableAPIRequest(
    "POST",
    `/api/ai/assistant/store/widget/${params.conversationId}/${params.messageId}`,
    {
      data: {
        widgetId: params.widgetId,
        apiId: params.apiKey,
        data: params.data,
      },
    },
  );
}
